module.exports = __webpack_public_path__ + "img/Blue-Robot.e0eca17f.svg";